export const WIDTH_BREAKPOINTS = [275, 400, 500, 608, 700, 980];
export const getThumbnailMinWidthAttribute = itemWidth => WIDTH_BREAKPOINTS.filter(breakpoint => breakpoint <= itemWidth).map(value => `${value}px`).join(' ');
//# sourceMappingURL=get-thumbnail-min-width-attribute.js.map